import { useEffect, useState, type Dispatch, type SetStateAction } from 'react'

// Drop-in useState replacement backed by sessionStorage, so state survives
// navigating away and back (e.g. list page filters) and page refreshes.
// Callers must use a storage key unique per page/field to avoid collisions.
export function usePersistedState<T>(key: string, defaultValue: T): [T, Dispatch<SetStateAction<T>>] {
  const [value, setValue] = useState<T>(() => {
    try {
      const stored = sessionStorage.getItem(key)
      return stored !== null ? (JSON.parse(stored) as T) : defaultValue
    } catch {
      return defaultValue
    }
  })

  useEffect(() => {
    try {
      sessionStorage.setItem(key, JSON.stringify(value))
    } catch {
      // ignore storage errors (quota exceeded, privacy mode, etc.)
    }
  }, [key, value])

  return [value, setValue]
}
